module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "id": _vm.name,
      "name": _vm.name
    },
    domProps: {
      "textContent": _vm._s(_vm.text)
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78d1d1d9!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/components/inputs/ButtonComponent.vue
// module id = 363
// module chunks = 1